export const LINK_MAP = {
  howDoesItWork: () => {
    return 'https://docs.cronos.org/for-users/crypto.com-card-top-up';
  },
  getCard: (isMobile: boolean) => {
    // both cronos and l2 share the same link
    return 'https://crypto.com/cards';
    // return isMobile
    //   ? 'https://app.mona.co/open_app?path=card'
    //   : 'https://crypto.com/cards';
  },
  gitbook: () => {
    return 'https://docs.cronos.org/for-users/crypto.com-card-top-up';
  },
  topUpLimitationLearnMore: () => {
    // both cronos and l2 share the same link
    return 'https://help.crypto.com/en/collections/3374054-crypto-com-visa-card-fees-limits';
  },
  cronosZkevmTopUp: () => 'https://zkevm.cronos.org/card',
} as const;

export const URL_SCHEME = {
  cdcAppAutoTopUp: 'https://app.mona.co/open_app?path=card/cardmanagement',
} as const;
